import React from 'react';
import Header from './Header';
import CountriesTable from './CountriesTable';
import FileUpload from './FileUpload';
import PaymentSection from './PaymentSection';

const ItemsPage = ({ items, countries, setIsModalOpen, handleDownload, onDeleteItem, onFileUpload, onUpdateStatus, isLoggedIn, username, onLoginClick }) => {
    return (
        <div className="min-h-screen bg-gray-100">
            <Header
                isLoggedIn={isLoggedIn}
                username={username}
                onLoginClick={onLoginClick}
            />

            {/* Main content */}
            <main className="container mx-auto p-6">
                <div className="page-header" id="items-page-header" data-test-id="page-header">
                    <div className="header-content flex justify-end items-center mb-6">
                        <div className="action-buttons" data-test-id="action-buttons">
                            <button
                                className="bg-green-500 text-white px-4 py-2 rounded mr-2 hover:bg-green-600 btn-create"
                                id="create-item-btn"
                                onClick={() => setIsModalOpen(true)}
                            >
                                Add Travel Item
                            </button>
                            <button
                                className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 btn-download"
                                id="download-btn"
                                data-test-id="download-button"
                                onClick={handleDownload}
                            >
                                Export Data
                            </button>
                        </div>
                    </div>
                </div>

                <CountriesTable
                    countries={countries}
                    onDeleteItem={onDeleteItem}
                    onUpdateStatus={onUpdateStatus}
                />
                <FileUpload onFileUpload={onFileUpload} />
                <PaymentSection />
            </main>
        </div>
    );
};

export default ItemsPage;